import React from 'react';
import './Documentacion.css';

const Documentacion = ({ onBack }) => {
    return (
        <div className="public-page">
            <button className="btn-secondary" onClick={onBack}>
                Volver
            </button>
            <header className="public-page-header">
                <h2>Documentación</h2>
                <p>Guías, API y documentación de uso de LOTEA.</p>
            </header>

            <section className="public-page-content">
                <h3>Resumen</h3>
                <p>
                    LOTEA es una plataforma para la gestión visual de lotes inmobiliarios. En esta página
                    verás instrucciones para levantar el proyecto localmente, los endpoints principales
                    y enlaces a guías específicas dentro del repositorio.
                </p>

                <h3>Instalación rápida</h3>
                <ol>
                    <li>Clona el repositorio: <code>git clone https://github.com/ruvaldev/Lotea.git</code></li>
                    <li>Backend: <code>cd backend && npm install</code>, copia <code>env.example</code> a <code>.env</code> y configura las variables; luego <code>npm start</code>.</li>
                    <li>Frontend: <code>cd frontend && npm install && npm start</code>.</li>
                </ol>

                <h3>Endpoints principales</h3>
                <ul>
                    <li><code>POST /api/auth/register</code> — Crear cuenta (se enviará un email de verificación; debes verificar antes de iniciar sesión)</li>
                    <li><code>POST /api/auth/login</code> — Iniciar sesión (recibe JWT). Si tu email no está verificado, recibirás un error Email no verificado.</li>
                    <li><code>GET /api/auth/verify?token=...</code> — Verificar cuenta desde el enlace en el email</li>
                    <li><code>POST /api/auth/resend-verification</code> — Reenviar email de verificación (body:  email )</li>
                    <li><code>GET /api/lotes</code> — Listar lotes (requiere autenticación)</li>
                    <li><code>POST /api/lotes</code> — Crear lote</li>
                    <li><code>PUT /api/lotes/:id</code> — Actualizar lote</li>
                    <li><code>DELETE /api/lotes/:id</code> — Eliminar lote</li>
                    <li><code>POST /api/planos</code> — Subir plano</li>
                    <li><code>POST /api/planos/:id/activate</code> — Marcar plano activo</li>
                </ul>

                <h3>Guías y recursos</h3>
                <ul>
                    <li><strong>Conexión MongoDB:</strong> <code>GUIA_CONEXION_MONGODB.md</code></li>
                    <li><strong>Formato de planos:</strong> <code>README_PLANO.md</code></li>
                    <li><strong>Ejemplos de datos:</strong> <code>DATOS_EJEMPLO.md</code></li>
                </ul>


            </section>
        </div>
    );
};

export default Documentacion;